import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Link, Redirect} from 'react-router-dom';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Modal } from 'react-bootstrap';
import getLocale from '../../i18n/getLocale';

class PaymentMonthControl extends Component {

  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      modal_days: false,
      modal_debts: false,
      modal_debt_payments: false,
      types_select: [
        { value: 'Missão', label: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesTipos.Missao },
        { value: 'Treinamento', label: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesTipos.Treinamento },
      ],
      mission_types_select: [
        { value: 'daily', label: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesMissao.Diarias },
        { value: 'base_chief', label: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesMissao.RepresentanteOperacional },
        { value: 'transport', label: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesMissao.Transporte },
        { value: 'distance', label: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesMissao.Deslocamento },
        { value: 'extra', label: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesMissao.Extra },
      ],
      training_types_select: [
        { value: 'daily', label: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesTreinamento.Diarias },
        { value: 'check', label: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesTreinamento.Cheques },
        { value: 'extra', label: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesTreinamento.Extra },
      ],
      simple_select: [
        { value: 1, label: this.locale.general.sim },
        { value: 0, label: this.locale.general.nao },
      ],
      sigtrip_grades_list: [],
      sigtrip_trainings_list: [],
      sigmec_grades_list: [],
      sigmec_trainings_list: [],
      grades_select: [],
      trainings_select: [],
      staffs_select: [],
      source: 'sigtrip',
      user_type: null,
      reference: null,
      show_opened: 1,
      period: null,
      date_start: null,
      date_finish: null,
      payments: [],
      consolidated: [],
      days: [],
      debts: [],
      debt_payments: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);
    this.openTutorial = this.openTutorial.bind(this);
    this.debtLabel = this.debtLabel.bind(this);
    this.scheduleExport = this.scheduleExport.bind(this);
    this.actionButton = this.actionButton.bind(this);
    this.exportSigmec = this.exportSigmec.bind(this);
    this.paymentDays = this.paymentDays.bind(this);
    this.staffDebtDays = this.staffDebtDays.bind(this);
    this.paymentDebts = this.paymentDebts.bind(this);
    this.staffDebtPayments = this.staffDebtPayments.bind(this);
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      if (name === 'source') {
        change['reference'] = null;
        change['payments'] = [];
        if(event.value == 'sigtrip'){
            change['grades_select'] = this.state.sigtrip_grades_list;
            change['trainings_select'] = this.state.sigtrip_trainings_list;
        }
        if(event.value == 'sigmec'){
            change['grades_select'] = this.state.sigmec_grades_list;
            change['trainings_select'] = this.state.sigmec_trainings_list;
        }
        if (event.value === 'sigtrip') {
          var self = this;
          var header = this.refs.request_api.header('application/json');
          Promise.resolve(header).then(function(value) {
            var url = config.get('api') + '/tripulantes/ativos/inscricao/lista';
            fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              if (responseJson.status === 'success') {
                self.setState({
                  staffs_select: responseJson.data,
                });
              }
            }).then(() => {
              self.setState({overlay: {message: '', type: '', status: 'closed'}});
              self.handleMessage();
            });
          });            
        }
        if (event.value === 'sigmec') {
          var self = this;
          var header = this.refs.request_api.header('application/json');
          Promise.resolve(header).then(function(value) {
            var url = config.get('api_sigmec') + '/colaboradores/inscricao/lista';
            fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              if (responseJson.status === 'success') {
                self.setState({
                  staffs_select: responseJson.data,
                });
              }
            }).then(() => {
              self.setState({overlay: {message: '', type: '', status: 'closed'}});
              self.handleMessage();
            });
          });
        }
      }
    }
    if (name === 'type') {
      change['reference'] = null;
      change['payments'] = [];
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  openTutorial () {
    window.open(config.get('cdn') + '/tutorials/extratos_pagamentos.pdf');
  }

  debtLabel (cell, row) {
    var botao = '';
    if (row.debt === 1 && row.credit === 1) {
      var botao = (
        <div className="btn-group">
          <p><i className="text-success fa fa-fw fa-warning"></i><i className="text-danger fa fa-fw fa-warning"></i></p>
        </div>
      );
    } else if(row.debt === 1) {
      var botao = (
        <div className="btn-group">
          <p className="text-danger"><i className="fa fa-fw fa-warning"></i></p>
        </div>
      );
    } else if(row.credit === 1) {
      var botao = (
        <div className="btn-group">
          <p className="text-success"><i className="fa fa-fw fa-warning"></i></p>
        </div>
      );
    }

    return botao;
  }

  exportSigmec(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn_sigmec') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }

  scheduleExport (cell, row) {
    if(row.order_type == 'Missão') {

      if(row.origin == 'SIGTRIP') {
        var url = config.get('cdn') + '/schedule_grades/main/' + row.schedule_link;
        var field = (
          <a className='btn btn-link btn-sm' href={url}>{row.revision}</a>
        );
      } else if(row.origin == 'SIGMEC') {
        var url = config.get('api_sigmec') + '/exportar/escala/grade/visualizar/' + row.schedule_link + '/1';
        var field = (
          <button className='btn btn-link btn-sm' onClick={() => this.exportSigmec(url)}>{row.revision}</button>
        );
      }
    } else {
      var field = row.revision;
    }
    
    return field;
  }

  actionButton (cell, row) {
    if(row.field_type == 'Pagamento' && row.order_id > 0) {
      var modalDaysBtn = '';
      if(row.payment_type == 'Diária' || row.payment_type == 'Transporte') {
        var modalDaysBtn = (
          <button className="btn button-inline btn-sm btn-primary" value={row.id} onClick={this.paymentDays}>
            <i className="fa fa-fw fa-calendar"></i>
          </button>
        );
      }

      var modalDebtsBtn = '';
      if(row.debt == 1) {
        var modalDebtsBtn = (
          <button className="btn button-inline btn-sm btn-danger" value={row.id} onClick={this.paymentDebts}>
            <i className="fa fa-info-circle"></i>
          </button>
        );
      }

      var botao = (
        <div className="btn-group">
          {modalDaysBtn}
          {modalDebtsBtn}
        </div>
      );

    } else if (row.field_type == 'Débito') {
      var modalDaysBtn = '';
      if(row.payment_type == 'Diária' || row.payment_type == 'Transporte') {
        var modalDaysBtn = (
          <button className="btn button-inline btn-sm btn-primary" value={row.id} onClick={this.staffDebtDays}>
            <i className="fa fa-fw fa-calendar"></i>
          </button>
        );
      }

      var botao = (
        <div className="btn-group">
          {modalDaysBtn}
          <button className="btn button-inline btn-sm btn-info" value={row.id} onClick={this.staffDebtPayments}>
            <i className="fa fa-info-circle"></i>
          </button>
        </div>
      );
    }
    return botao;
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamentos/controle/mensal';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
            self.setState({
                sigtrip_grades_list: responseJson.sigtrip_grades_list,
                sigtrip_trainings_list: responseJson.sigtrip_trainings_list,
                grades_select: responseJson.sigtrip_grades_list,
                trainings_select: responseJson.sigtrip_trainings_list,
                staffs_select: responseJson.sigtrip_staffs_list,
            });
        }
      }).then(() => {
      var url = config.get('api_sigmec') + '/pagamentos/controle/mensal';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({
                sigmec_grades_list: responseJson.sigmec_grades_list,
                sigmec_trainings_list: responseJson.sigmec_trainings_list,
            });
        }
      }).then(() => {
      var url = config.get('api') + '/checar/origem/usuario';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({
                user_type: responseJson.data,
            });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); }); });
    });
  }

  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    if (this.state.user_type === 'sigtrip') {
      var api = 'api';
    } else if (this.state.user_type === 'sigmec') {
      var api = 'api_sigmec';
    }
    var datasave = {
      period: this.state.period,
      type: this.state.type,
      payment_type: this.state.payment_type,
      show_opened: this.state.show_opened,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get(api) + '/pagamentos/controle/extrato/mensal', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({ 
          payments: responseJson.data.payments,
          consolidated: responseJson.data.consolidated,
        });
        if(responseJson.status == 'error') {
          self.handleAlert(responseJson.message, responseJson.status, 'open');

        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  paymentDays (event) {
    var payment_id = event.currentTarget.value;
    var self = this;
    self.handleAlert('', '', 'open');
    if (this.state.user_type === 'sigtrip') {
      var api = 'api';
    } else if (this.state.user_type === 'sigmec') {
      var api = 'api_sigmec';
    }
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get(api) + '/pagamentos/dias/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.handleAlert('', '', 'closed');
          self.setState({days: responseJson.data, modal_days: true});
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  staffDebtDays (event) {
    var staff_debt_id = event.currentTarget.value;
    var self = this;
    self.handleAlert('', '', 'open');
    if (this.state.user_type === 'sigtrip') {
      var api = 'api';
    } else if (this.state.user_type === 'sigmec') {
      var api = 'api_sigmec';
    }
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get(api) + '/saldo/devedor/dias/' + staff_debt_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.handleAlert('', '', 'closed');
          self.setState({days: responseJson.data, modal_days: true});
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  paymentDebts (event) {
    var payment_id = event.currentTarget.value;
    var self = this;
    self.handleAlert('', '', 'open');
    if (this.state.user_type === 'sigtrip') {
      var api = 'api';
    } else if (this.state.user_type === 'sigmec') {
      var api = 'api_sigmec';
    }
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get(api) + '/pagamentos/saldos/devedores/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.handleAlert('', '', 'closed');
          self.setState({debts: responseJson.data, modal_debts: true});
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  staffDebtPayments (event) {
    var staff_debt_id = event.currentTarget.value;
    var self = this;
    self.handleAlert('', '', 'open');
    if (this.state.user_type === 'sigtrip') {
      var api = 'api';
    } else if (this.state.user_type === 'sigmec') {
      var api = 'api_sigmec';
    }
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get(api) + '/saldo/devedor/pagamentos/' + staff_debt_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.handleAlert('', '', 'closed');
          self.setState({debt_payments: responseJson.data, modal_debt_payments: true});
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.titulo}</h3>
      <hr/>
      <button className="btn btn-primary pull-right" onClick={this.openTutorial}>
        <i className="fa fa-file-pdf-o"> Tutorial</i>
      </button>
      <p>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.paragrafoOControleExibeTodosOspagamentos}</p>
      <p>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.paragrafoADataDeReferenciaParaAPesquisa}</p>
      <hr/>
      <form onSubmit={this.search}>
        <div className="row">
        <div className="col-md-6 form-group">
            <label>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.formulario.Periodo}:</label>
            <InputMask value={this.state.period} required maskChar={null} name="date" mask="99/9999" className="form-control" onChange={this.handleChange.bind(this, 'period')} placeholder={this.locale.general.mesAno} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.formulario.ExibirPagamentosAbertos}?</label>
            <Select
              className=""
              name="show_opened"
              value={this.state.show_opened}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'show_opened')}
              options={this.state.simple_select}
              required
            />
          </div>
        </div>
        {/* <div className="row">
          <div className="col-md-6 form-group">
              <label>Tipo de Ordem:</label>
              <Select
                className=""
                name="type"
                value={this.state.type}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={this.state.types_select}
              />
            </div>
            <div className="col-md-6 form-group">
              <label>Tipo de Pagamento:</label>
              {
                (this.state.type === 'Missão') ?
                <Select
                  className=""
                  name="payment_type"
                  value={this.state.payment_type}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'payment_type')}
                  options={this.state.mission_types_select}
                />
                : (this.state.type === 'Treinamento') ?
                <Select
                  className=""
                  name="payment_type"
                  value={this.state.payment_type}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'payment_type')}
                  options={this.state.training_types_select}
                />
                :
                <Select
                  className=""
                  name="payment_type"
                  value={this.state.payment_type}
                  searchable={true}
                  placeholder={'Selecione um tipo de ordem'}
                  onChange={this.handleSelectChange.bind(this, 'payment_type')}
                />
              }
            </div>
        </div> */}
        <hr/>
        <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block" required><i className="fa fa-fw fa-save"></i> {this.locale.general.buscar}</button>
        </div>
      </form>
      <hr/>
      <BootstrapTable data={this.state.consolidated} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaSaldos.semSaldoAnterior}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
            <TableHeaderColumn dataField="previous_balance" isKey={true} dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaSaldos.SaldoAnterior}</TableHeaderColumn>
        </BootstrapTable>
        <hr/>
        <BootstrapTable data={this.state.payments} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.semPagamentos}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
            <TableHeaderColumn dataField="base" isKey={true} dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.BaseOperacional}</TableHeaderColumn>
            {/* <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='240'>Frota</TableHeaderColumn> */}
            <TableHeaderColumn dataField="period" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='240'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Periodo}</TableHeaderColumn>
            <TableHeaderColumn dataField="order_type" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.TipoDeOrdem}</TableHeaderColumn>
            <TableHeaderColumn dataField="training" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='240'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Treinamento}</TableHeaderColumn>
            <TableHeaderColumn dataField="code" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.CodigoDeControle}</TableHeaderColumn>
            <TableHeaderColumn dataField="revision" dataAlign="center" dataFormat={this.scheduleExport} dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Revisao}</TableHeaderColumn>
            <TableHeaderColumn dataField="payment_type" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.TipoDePagamento}</TableHeaderColumn>
            {/* <TableHeaderColumn dataField="id" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>ID</TableHeaderColumn> */}
            <TableHeaderColumn dataField="status" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Status}</TableHeaderColumn>
            {/* <TableHeaderColumn dataField="order" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>Ordem</TableHeaderColumn> */}
            {/* <TableHeaderColumn dataField="debt" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120' dataFormat={this.debtLabel}>Saldo</TableHeaderColumn> */}
            <TableHeaderColumn dataField="qty" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Quantidade}</TableHeaderColumn>
            <TableHeaderColumn dataField="value" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.ValorUnitario}</TableHeaderColumn>
            <TableHeaderColumn dataField="original_amount" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.ValorOriginal}</TableHeaderColumn>
            <TableHeaderColumn dataField="debt_charge" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Desconto}</TableHeaderColumn>
            {/* <TableHeaderColumn dataField="debt_ids" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>IDs Débitos</TableHeaderColumn> */}
            <TableHeaderColumn dataField="total" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.ValorRecebido}</TableHeaderColumn>
            <TableHeaderColumn dataField="balance" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Saldo}</TableHeaderColumn>
            <TableHeaderColumn dataField="payment_date" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.DataDoPagamento}</TableHeaderColumn>
            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.actionButton} dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Acoes}</TableHeaderColumn>
        </BootstrapTable>
        <hr/>
        <BootstrapTable data={this.state.consolidated} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaValores.semValores}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
            <TableHeaderColumn dataField="original_amount" isKey={true} dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaValores.ValorOriginal}</TableHeaderColumn>
            <TableHeaderColumn dataField="debt" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaValores.Desconto}</TableHeaderColumn>
            <TableHeaderColumn dataField="total" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaValores.ValorRecebido}</TableHeaderColumn>
            <TableHeaderColumn dataField="balance" dataAlign="center" dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaValores.Saldo}</TableHeaderColumn>
        </BootstrapTable>
        <Modal show={this.state.modal_days} aria-labelledby="contained-modal-title">
          <Modal.Header>
            <h4 className="pull-left">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tituloDiasDoPagamento}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_days: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive">
              <table className="table table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th className="text-center vcenter">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDiasDoPagamento.Data}</th>
                    <th className="text-center vcenter">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDiasDoPagamento.Diarias}</th>
                  </tr>
                </thead>
                <tbody>
                {Object.keys(self.state.days).length > 0 ?
                Object.keys(self.state.days).map(function(k) {
                  var day = self.state.days[k];
                  return (
                    <tr key={day.id}>
                      <td className="text-center vcenter">{day.date_str}</td>
                      <td className="text-center vcenter">{day.coefficient}</td>
                    </tr>
                  );
                }):
                <tr>
                  <td colSpan="2" className="text-center vcenter">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDiasDoPagamento.nenhumDiaEncontrado}</td>
                </tr>
                  }
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_days: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.modal_debts} aria-labelledby="contained-modal-title">
          <Modal.Header>
            <h4 className="pull-left">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tituloDescontosRelacionados}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_debts: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive">
              <table className="table table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th className="text-center vcenter">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDescontosRelacionados.IdDoDebito}</th>
                    <th className="text-center vcenter">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDescontosRelacionados.ReferenciaDoDebito}</th>
                    <th className="text-center vcenter">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDescontosRelacionados.ValorOriginalDoDebito}</th>
                    <th className="text-center vcenter">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDescontosRelacionados.ValorAmortizadoNoPagamento}</th>
                  </tr>
                </thead>
                <tbody>
                {Object.keys(self.state.debts).map(function(k) {
                  var debt = self.state.debts[k];
                  return (
                    <tr key={debt.id}>
                      <td className="text-center vcenter">{debt.staff_debt_id}</td>
                      <td className="text-center vcenter">{debt.reference}</td>
                      <td className="text-center vcenter">{debt.staff_debt_value}</td>
                      <td className="text-center vcenter">{debt.charge}</td>
                    </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_debts: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.modal_debt_payments} aria-labelledby="contained-modal-title">
          <Modal.Header>
            <h4 className="pull-left">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tituloPagamentosRelacionados}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_debt_payments: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive">
              <table className="table table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th className="text-center vcenter">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentosRelacionados.IdDoDebito}</th>
                    <th className="text-center vcenter">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentosRelacionados.ReferenciaDoPagamento}</th>
                    <th className="text-center vcenter">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentosRelacionados.ValorOriginalDoDebito}</th>
                    <th className="text-center vcenter">{this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentosRelacionados.ValorAmortizadoNoPagamento}</th>
                  </tr>
                </thead>
                <tbody>
                {Object.keys(self.state.debt_payments).map(function(k) {
                  var debt_payment = self.state.debt_payments[k];
                  return (
                    <tr key={debt_payment.id}>
                      <td className="text-center vcenter">{debt_payment.payment_id}</td>
                      <td className="text-center vcenter">{debt_payment.reference}</td>
                      <td className="text-center vcenter">{debt_payment.staff_debt_value}</td>
                      <td className="text-center vcenter">{debt_payment.charge}</td>
                    </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_debt_payments: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentMonthControl;


// WEBPACK FOOTER //
// ./src/Components/Controls/PaymentMonthControl.js